export const formNaming = {
  NEW_COMMUNICATION_FORM: 'new-communication-form',
  NEW_COMMUNICATION_FORM_OT: 'new-communication-form-OT',
  NEW_COMMUNICATION_FORM_CAMPAIGN: 'new-communication-form-Campaign',

  NEW_DUPLICATE_COMMUNICATION_FORM: 'new-duplicate-communication-form',
  NEW_DUPLICATE_COMMUNICATION_FORM_OT: 'new-duplicate-communication-form-OT',
  NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN: 'new-duplicate-communication-form-Campaign',

  EDIT_COMMUNICATION_FORM: 'edit-communication-form',
  EDIT_COMMUNICATION_FORM_OT: 'edit-communication-form-OT',
  EDIT_COMMUNICATION_FORM_CAMPAIGN: 'edit-communication-form-Campaign',

  // Navigation context for context-aware redirects
  COMMUNICATION_NAVIGATION_CONTEXT: 'communication-navigation-context',
};
